module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.isOpen ? 'open' : ''],
    attrs: {
      "id": "right-side-bar"
    }
  }, [_c('span', {
    staticClass: "close-float-top-right"
  }, [_c('i', {
    staticClass: "fa fa-times",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "right-side-bar-content"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.$emit('sidebarSubmitted')
      }
    }
  }, [_c(_vm.component, {
    tag: "component",
    attrs: {
      "isOpen": _vm.isOpen,
      "callerId": _vm.callerId,
      "event": _vm.event,
      "initData": _vm.data,
      "title": _vm.title
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-abe21ca8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RightSidebar.vue
// module id = 2267
// module chunks = 1